module.exports = __webpack_public_path__ + "static/media/ic-trust.8ca46566.svg";